import { ERROR_CODE
       , ERROR_MSG
       , tr_error }                from '../00_assets'

import { API_METHOD
       , api_response_t
       , connect_t
       }                           from './01_api_types'

import { get
       , post
       , put
       , del
       }                           from './03_api_connect'


export type effect_cb = ( value: api_response_t ) => api_response_t ;

interface IRestOptions
{
  credentials?: boolean
  effect?: effect_cb ;
}

class REST
{
  protected _api_url : string ;
  protected _effect : effect_cb ;

  public static ALL_METHODS =
    [ API_METHOD.LIST 
    , API_METHOD.ADD
    , API_METHOD.UPDATE
    , API_METHOD.DEL
    , API_METHOD.FETCH ] ;

  public static ALL_METHODS_AND_POST =
    REST.ALL_METHODS.concat( [ API_METHOD.POST ] ) ;

  public list?   : ( data?: object             ) => Promise< api_response_t >
  public add?    : ( opts: object              ) => Promise< api_response_t >
  public fetch?  : ( id: number                ) => Promise< api_response_t >
  public update? : ( id: number, opts : Object ) => Promise< api_response_t >
  public del?    : ( id: number                ) => Promise< api_response_t >
  public post?   : ( opts: object              ) => Promise< api_response_t >



  constructor ( api_url: string
              , allowed_methods : API_METHOD[] = REST.ALL_METHODS
              , call_opts: IRestOptions = { credentials: false } )
  {
    this._api_url = api_url ;
    this._effect = call_opts.effect || (a => a) ;

    // METODOS VIRTUALES
    for ( let method of allowed_methods )
    switch ( method )
          {
             case API_METHOD.LIST: 
                  this.list = ( data: object = { } ) =>
                    this.request( ( ) => get( this._api_url, data, call_opts ) ) ;
                  break ;

             case API_METHOD.ADD:
                  this.add = ( opts : Object ) =>
                    this.request( ( ) => post( this._api_url, opts, call_opts ) ) ;
                  break ;

             case API_METHOD.FETCH:
                  this.fetch = ( id: number ) =>
                    this.request( ( ) => get( this.url_with_id( id ), {}, call_opts ) ) ;
                  break ;

             case API_METHOD.UPDATE:
                  this.update = ( id: number, opts : Object ) => 
                    this.request( ( ) => put( this.url_with_id( id ), opts, call_opts ) ) ;
                  break ;
             
             case API_METHOD.DEL:
                  this.del = ( id : number ) => 
                    this.request( ( ) => del( this.url_with_id( id ), call_opts ) ) ;
                  break ;
          }
  }

  protected url_with_id ( id : number ) : string
  {
    return this._api_url + '/' + id ;
  }


  protected async request ( fn: ( ) => Promise< connect_t > )
  {
    try
    {
      const data = await fn( )
          , code = (data as any).status || ERROR_CODE.NONE ;

      return this._effect( { data: data, error: { code } } ) ;
    }
    catch ( error )
    {
      return { data: null
              , error: 
                { msg: tr_error( error, ERROR_MSG.GENERAL )
                , code: error.code === undefined? -1 : error.code } } ;
    }
  }
}


export default REST ;